"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastRuleChangeEnum = void 0;
var ForecastRuleChangeEnum;
(function (ForecastRuleChangeEnum) {
    ForecastRuleChangeEnum["CREATION"] = "CREATION";
    ForecastRuleChangeEnum["UPDATE"] = "UPDATE";
    ForecastRuleChangeEnum["DELETION"] = "DELETION";
})(ForecastRuleChangeEnum || (exports.ForecastRuleChangeEnum = ForecastRuleChangeEnum = {}));
